// extracted by mini-css-extract-plugin
module.exports = {"fullScreen":"Loading_fullScreen__3Lq9c"};